import React, { useState, useEffect, useMemo } from 'react';
import {
  Container,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { IAssociationTable, ITarget } from '../../types/interfaces';

import { getFtpScan } from '../../flux/actions/clientActions';
import TableContainer from "../tables_manager/TableContainer"
import { SelectColumnFilter, NumberRangeColumnFilter } from '../tables_manager/filters';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faInfoCircle, faExternalLinkAlt, faPrint, faPhone, faClipboard, faCheckCircle, faIdCard, faExpandArrowsAlt, faCheck, faFileInvoice } from '@fortawesome/free-solid-svg-icons'
import moment from "moment";
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import Loading from '../Loading';
import ReactTooltip from 'react-tooltip';
import PDFLink from '../pdf/PDFLink';
import { constants } from '../../types/constants';

const AssociationTable = ({ 
  linesData,
  setAssociationPartInfo,
  chooseAssociation,
  vente,
  embed,
 }: IAssociationTable) => {
  const alert = useAlert();
  
  const columns = [
    ...(chooseAssociation ? [{
      Header: "Choisir",
      className: "text-center",
      Cell: ({ row }) => (
          <Container className="actionsContainer">
            <button className="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light"
              onClick={() => chooseAssociation(row.original.id)}
              title="Choisir">
              <FontAwesomeIcon icon={faCheck} />
            </button>
          </Container>
      ),
      disableSortBy: true,
    }] : []),
    {
      Header: "ID Association",
      accessor: "id",
      // hidden: true
    },
    {
      Header: "Étage",
      accessor: "ETAGE",
      Cell: ({ value }) => value === "0" ? "RDC" : (value ? `Étage ${value}` : "-")
    },
    {
      Header: "Pourcentage",
      accessor: "POURCENTAGE",
      Cell: ({ value }) => value ? `${value}%` : "-"
    },
    {
      Header: "Type",
      accessor: "TYPE",
      hidden: true,
      Cell: ({ value }) => value === constants.APPARTEMENT ? "Appartement" : value === constants.MAGASIN ? "Magasin" : (value || "-")
    },
    {
      Header: "Position",
      accessor: "POSITION",
      Cell: ({ value }) => value || "-"
    },
    {
      Header: "Superficie",
      accessor: "SUPERFICIE",
      Cell: ({ value }) => value ? `${value}m²` : "-"
    },
    {
      Header: "Saisie le",
      accessor: "createdAt",
      customExportDisplay: `$.createdAt ? new Date($.createdAt).toLocaleString('fr') : ""`,
      filter: (rows, id, e) => rows.filter(t => t.original[id] && moment(t.original[id]).format('DD/MM/YYYY').includes(e)),
      Cell: ({ value }) => value ? <div title={moment(value).format('DD/MM/YYYY - HH:mm')}>{moment(value).locale('fr').calendar({
          sameDay: '[Aujourd\'hui à] HH:mm',
          nextDay: 'DD/MM/YYYY à HH:mm',
          nextWeek: 'DD/MM/YYYY à HH:mm',
          lastDay: '[Hier à] HH:mm',
          lastWeek: 'DD/MM/YYYY à HH:mm',
          sameElse: 'DD/MM/YYYY à HH:mm'
      })}</div> : "-",
      hidden: true
    },
    {
      Header: "Clients",
      accessor: "contrat_clients",
      Cell: ({ value }) => <div>{value?.map((e, key) => <div key={key}>{`${e.client?.NOM || "-"} ${e.client?.PRENOM || ""}`}</div>)}</div>
    },
    {
      Header: "Prix de Vente",
      accessor: "PRIX_VENTE",
      Filter: (e) => NumberRangeColumnFilter({...e, isPrice: true}),
      filter: 'between',
      // filter: (rows, id, e) => rows.filter(t => Number(((+t.original[id]) || 0).toFixed(2)).toString().includes((e || "").replace(",", "."))),
      sortType: (a, b, id, desc) => ((a.original[id] !== null && a.original[id] !== undefined && a.original[id] != "") ? Number(a.original[id]) : 0)
                                  > ((b.original[id] !== null && b.original[id] !== undefined && b.original[id] != "") ? Number(b.original[id]) : 0) ? 1 : -1,
      Cell: ({ value }) => (value !== null && value !== undefined && value != "") ? <div style={{fontWeight: 600}}>{value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Dh</div> : "-"
    },
    {
      Header: "encaissements",
      accessor: "contrat_encaissements",
      Cell: ({ value }) => <div>{value?.length > 1 ? value.map((e, key) => <div key={key}>{e.PART ? e.PART.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh" : "-"}</div>) : null}<div className="assoEncTotalDiv">{value?.length > 1 ? "Total: " : null}{(value?.reduce((e, t) => {
        return t.PART ? e + t.PART : e
      }, 0) || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh" || "-"}</div></div>
    },
    {
      Header: "Reliquat",
      Cell: ({ row: {original} }) => (original.PRIX_VENTE !== null && original.PRIX_VENTE !== undefined && original.PRIX_VENTE != "" && original.contrat_encaissements) ? <div style={{fontWeight: 600}}>{(original.PRIX_VENTE - original.contrat_encaissements.reduce((e, t) => {
        return t.PART ? e + t.PART : e
      }, 0)).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Dh</div> : "-"
    },
    {
      Header: "Détails",
      className: "text-center",
      Cell: ({ row: {original} }) => (
          <Container className="actionsContainer">
              <button className="btn btn-info btn-rounded btn-sm my-0 waves-effect waves-light"
                onClick={() => {
                  if(setAssociationPartInfo)
                    setAssociationPartInfo(original)
                }}
                title="Plus de détails">
                <FontAwesomeIcon icon={faExpandArrowsAlt} />
              </button>
              <PDFLink documentType={"part"}
                  data={{...original, hasPermission: vente?.hasPermission, contrat_encaissements: vente?.contrat_encaissements?.filter(e => e.ID_ASS == original.id), contrat_clients: vente?.contrat_clients?.filter(e => e.ID_ASS == original.id), contrat: vente || {}}}
                  download={false}
                  buttonText=""
                  iconSize="inherit"
                  // customClassNames="btn btn-info"
                  customButtonIcon={faFileInvoice}
                  allowPrintPreview={true}
                  htmlTitle="Voir la fiche Part"
                  customClassNames="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                   />
          </Container>
      ),
      disableSortBy: true,
    }
  ];

  return (
    <div className="fadeAnimation mt-3">
      <Container style={embed ? {maxWidth: "100%"} : {}}>
        <TableContainer columns={columns} data={linesData} dataName="associations" enableCheckBox={false} disableFilter={true} hideExport={!!embed} />
      </Container>
    </div>
  );
};

export default connect(null, {  })(AssociationTable);
